import { useState } from "react";
import { Trash2, Plus } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { OPC, fmtDate, fmtEur, today } from "@/lib/api";

export const PagosEditor = ({ pagos, onChange }) => {
  const [n, setN] = useState({ fecha: today(), importe: "", metodo: "Tarjeta", concepto: "" });
  const add = () => {
    if (!Number(n.importe)) return;
    onChange([...pagos, { ...n, id: crypto.randomUUID(), importe: Number(n.importe) }]);
    setN({ ...n, importe: "", concepto: "" });
  };
  return (
    <div className="space-y-3">
      <div className="grid grid-cols-2 sm:grid-cols-[140px_110px_140px_1fr_auto] gap-2">
        <Input type="date" data-testid="pago-fecha" value={n.fecha} onChange={(e) => setN({ ...n, fecha: e.target.value })} className="h-8 text-sm" />
        <Input type="number" data-testid="pago-importe" placeholder="Importe €" value={n.importe} onChange={(e) => setN({ ...n, importe: e.target.value })} className="h-8 text-sm" />
        <select data-testid="pago-metodo" className="field-select h-8" value={n.metodo} onChange={(e) => setN({ ...n, metodo: e.target.value })}>
          {OPC.metodo_pago.map((m) => <option key={m}>{m}</option>)}
        </select>
        <Input data-testid="pago-concepto" placeholder="Concepto" value={n.concepto} onChange={(e) => setN({ ...n, concepto: e.target.value })} className="h-8 text-sm" />
        <Button type="button" size="sm" data-testid="pago-add" onClick={add} className="bg-[#1E3A8A] hover:bg-[#1E40AF]"><Plus className="h-4 w-4 mr-1" />Registrar</Button>
      </div>
      <div className="divide-y divide-slate-100 border border-slate-200 rounded-md">
        {pagos.length === 0 && <p className="text-sm text-slate-400 p-3">No hay pagos registrados.</p>}
        {pagos.map((p, i) => (
          <div key={p.id} data-testid={`pago-row-${i}`} className="flex items-center gap-3 px-3 py-2 text-sm">
            <span className="w-24 text-slate-500">{fmtDate(p.fecha)}</span>
            <span className="w-24 font-[JetBrains_Mono] font-semibold text-slate-900">{fmtEur(p.importe)}</span>
            <span className="w-28 text-slate-600">{p.metodo}</span>
            <span className="flex-1 text-slate-500 truncate">{p.concepto}</span>
            {p.factura && <span className="rounded bg-emerald-50 px-1.5 py-0.5 text-[10px] font-semibold text-emerald-700" data-testid={`pago-factura-${i}`}>Factura {p.factura}</span>}
            {!p.factura && <button type="button" data-testid={`pago-remove-${i}`} onClick={() => onChange(pagos.filter((_, j) => j !== i))} className="text-slate-400 hover:text-rose-600"><Trash2 className="h-4 w-4" /></button>}
          </div>
        ))}
      </div>
    </div>
  );
};
